import React, { useState } from "react";
import { initialFilter } from "./definitions";
import PropTypes from "prop-types";
import { useKycFile } from "../../../../hooks/useKycFile";

interface KycFlowUIProps {
  children: React.ReactNode;
}

export interface KycFlowUiContextValue {
  filters: any[];
  setFilters: (value: any[]) => void;
  filtersUI: any[];
}

export const KycFlowUIContext = React.createContext<KycFlowUiContextValue>({
  filters: [],
  setFilters: () => undefined,
  filtersUI: [],
});

export const KycFlowUIProvider = ({ children }: KycFlowUIProps): JSX.Element => {
  const filesContext = useKycFile();
  const [filters, setFilters] = useState<any[]>([initialFilter]);

  return (
    <KycFlowUIContext.Provider
      value={{
        ...filesContext,
        filters,
        setFilters,
        filtersUI: [...filters],
      }}
    >
      {children}
    </KycFlowUIContext.Provider>
  );
};

KycFlowUIProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const KycFlowUIConsumer = KycFlowUIContext.Consumer;
